import React from "react";
import PropTypes from "prop-types";

import { Button, Card, Col, Empty, Row, Space, Tag, Typography } from "antd";

import { formatAmount, purchaseStage } from "../../../../../constants/marketplaceCheckout";

const { Text, Title } = Typography;

const ACTION_LABELS = {
    VALIDATE: "Valider l'accord",
    PAY: "Livraison et paiement",
    FOLLOW_PAYMENT: "Suivre le paiement",
    TRACK: "Suivi de la commande"
};

/**
 * Accords de l'utilisateur et leur avancement post-Agreement
 * (checkout, paiement, commande, livraison).
 */
const AgreementList = ({ agreements = [], currentUserId, onSelect, onPay }) => {
    if (agreements.length === 0) {
        return <Empty description="Aucun accord" />;
    }

    return (
        <Row gutter={[16, 16]}>
            {agreements.map(agreement => {
                const stage = purchaseStage(agreement, currentUserId);
                const amount = agreement.totalAmount ?? agreement.productAmount;
                const onAction = stage.action === "VALIDATE" ? onSelect : onPay;

                return (
                    <Col key={agreement.id} xs={24} sm={12} lg={8}>
                        <Card>
                            <Title level={5} style={{ marginTop: 0 }}>Accord commercial</Title>
                            <Space orientation="vertical" style={{ width: "100%" }}>
                                <Text type="secondary">
                                    {agreement.agreedNumberOfPackets} paquet(s)
                                    {amount !== null && amount !== undefined ? ` · ${formatAmount(amount, agreement.currency)}` : ""}
                                </Text>
                                <Tag color={stage.color}>{stage.label}</Tag>
                                {stage.action && (
                                    <Button
                                        type={stage.action === "TRACK" ? "default" : "primary"}
                                        block
                                        disabled={!agreement.inquiryId}
                                        onClick={() => onAction?.(agreement)}
                                    >
                                        {ACTION_LABELS[stage.action]}
                                    </Button>
                                )}
                                {stage.action && !agreement.inquiryId && (
                                    <Text type="danger">Demande d'origine introuvable pour cet accord.</Text>
                                )}
                            </Space>
                        </Card>
                    </Col>
                );
            })}
        </Row>
    );
};

AgreementList.propTypes = {
    agreements: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        inquiryId: PropTypes.string,
        buyerId: PropTypes.string,
        sellerId: PropTypes.string,
        status: PropTypes.string,
        currency: PropTypes.string,
        agreedNumberOfPackets: PropTypes.number,
        totalAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        productAmount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        checkoutStatus: PropTypes.string,
        latestPaymentStatus: PropTypes.string,
        orderId: PropTypes.string,
        orderNumber: PropTypes.number,
        deliveryStatus: PropTypes.string
    })),
    currentUserId: PropTypes.string,
    onSelect: PropTypes.func,
    onPay: PropTypes.func
};

export default AgreementList;
